import { twMerge } from "tailwind-merge";
import { motion } from "framer-motion";

export default function BrandButton({
  text,
  onClick,
  disabled,
  variant = undefined,
  className,
}: {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: string;
  className?: string;
}) {

  return (
    <motion.button
      onClick={onClick}
      disabled={disabled}
      whileTap={{ scale: 0.98 }}
      whileHover={{ scale: 1.02 }}
      // set animtion duration
      transition={{ duration: 0.1 }}
      className={twMerge(
        "bg-gradient-to-b from-green-500 to-green-600 hover:from-green-500 hover:to-green-500 text-white font-bold py-2 px-4 rounded disabled:opacity-50 w-fit",
        className
      )}
    >
      {text}
    </motion.button>
  );
}
